/**
 * True when the user is dragging files from outside the page (OS / browser file drag).
 * In-page drags (e.g. reorder) use other MIME types and must not trigger global file-drop UI.
 */
export function isExternalFileDrag(event: DragEvent): boolean {
  return Array.from(event.dataTransfer?.types ?? []).includes('Files')
}
